import React from 'react'

const NotFound = () => (
  <main className="modal-page-content">
    <div className="container">
      <h1>404 - Not Found</h1>
      <div className="flow-text">That's unfortunate. Where did it go?</div>
    </div>
  </main>
)

export default NotFound
